import { render, staticRenderFns } from "./DeactivateAdvanceUser.vue?vue&type=template&id=6338b35f&scoped=true&"
import script from "./DeactivateAdvanceUser.vue?vue&type=script&lang=js&"
export * from "./DeactivateAdvanceUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateAdvanceUser.vue?vue&type=style&index=0&id=6338b35f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338b35f",
  null
  
)

export default component.exports